import React, { useRef, type ChangeEvent } from "react";

import styles from "~/pages/CharacterSheet/widgets/ActionButtons/ActionButtons.module.scss";
import { Button } from "~/widgets/Button/Button";

type ActionButtonsProps = {
  onDamage: () => void;
  onHeal: () => void;
  onDirectDamage: () => void;
  onSpendResilience: () => void;
  onImport: (event: ChangeEvent<HTMLInputElement>) => void;
  onExport: () => void;
  onOpenCharacterSearch: () => void;
  onOpenSettings: () => void;
};

function ActionButtons({
  onDamage,
  onHeal,
  onDirectDamage,
  onSpendResilience,
  onImport,
  onExport,
  onOpenCharacterSearch,
  onOpenSettings,
}: ActionButtonsProps): React.ReactElement {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const triggerImport = (): void => {
    fileInputRef.current?.click();
  };

  return (
    <div className={styles.actionButtons}>
      <input
        type="file"
        ref={fileInputRef}
        accept=".json"
        onChange={onImport}
      />
      <Button
        type="button"
        variant="danger"
        size="sm"
        title="Hotkey: D"
        onClick={onDamage}
      >
        Damage
      </Button>
      <Button
        type="button"
        variant="success"
        size="sm"
        title="Hotkey: H"
        onClick={onHeal}
      >
        Heal
      </Button>
      <Button
        type="button"
        variant="danger"
        size="sm"
        title="Hotkey: X"
        onClick={onDirectDamage}
      >
        Direct Dmg
      </Button>
      <Button
        type="button"
        variant="primary"
        size="sm"
        title="Hotkey: V"
        onClick={onSpendResilience}
      >
        Spend Res.
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        title="Import character data from JSON"
        onClick={triggerImport}
      >
        Import
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        title="Export character data as JSON"
        onClick={onExport}
      >
        Export
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        title="Switch character (Hotkey: C)"
        onClick={onOpenCharacterSearch}
      >
        Switch
      </Button>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        title="Open settings"
        onClick={onOpenSettings}
      >
        ⚙
      </Button>
    </div>
  );
}

export default ActionButtons;
